import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route as DomRoute,
  useLocation
} from 'react-router-dom';
import { Widget } from './widget/widget';
import { PaymentKo } from './payment/paymentKo';
import { PaymentOk } from './payment/paymentOk';
import { PaymentCheck } from './payment/paymentCheck';
import { Layout } from './layout/layout';
import { Checkout } from './transfer/checkout';
import { Destination } from './transfer/destination';
import { Beneficiary } from './transfer/beneficiary';
import { Options } from './transfer/options';
import { useAuth } from './context';
import { LocationsView } from './locations/locationsView';
import ReactGA from 'react-ga';
import { Config } from './config';

const config = new Config();
if (config.GOOGLE_ANALITYCS_ID) {
  ReactGA.initialize(config.GOOGLE_ANALITYCS_ID);
}

const Route = ({ component: Component, ...rest }: { component: any, exact?: boolean, path: string[] | string }) => (
  <DomRoute {...rest} render={(props) => <Layout><Component {...props} /></Layout>} />
)

const WidgetRoute = ({ component: Component, ...rest }: { component: any, exact?: boolean, path: string[] | string }) => (
  <DomRoute {...rest} render={(props) => <Component {...props} />} />
)

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (config.GOOGLE_ANALITYCS_ID) {
      ReactGA.pageview(pathname);
    }
  }, [pathname]);
  return null;
}

export const Router = () => {
  const auth = useAuth();
  React.useEffect(() => {
    auth.attemptNonInteractiveLogin();
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        <Route exact path={['/transfer/destination', '/transfer']} component={Destination} />
        <Route exact path='/transfer/options' component={Options} />
        <Route exact path='/transfer/beneficiary' component={Beneficiary} />
        <Route exact path='/transfer/checkout' component={Checkout} />
        <Route exact path='/payments/check' component={PaymentCheck} />
        <Route exact path='/payments/ok' component={PaymentOk} />
        <Route exact path='/payments/ok/:transactionId' component={PaymentOk} />
        <Route exact path='/payments/ko/:transactionId' component={PaymentKo} />
        <Route exact path='/payments/ko' component={PaymentKo} />
        <Route exact path='/locations' component={LocationsView} />
        <WidgetRoute path='/widget' component={Widget} />
        <Route path='/' component={Destination} />
      </Switch>
    </BrowserRouter>
  );
}
